import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, Paginations } from "../../../Constant";
import DefaultPagination from "./DefaultPagination";
import PaginationActiveAndDisabled from "./PaginationActiveAndDisabled";
import PaginationWithIcons from "./PaginationWithIcons";
import RoundedPagination from "./RoundedPagination";
import PaginationAlignment from "./PaginationAlignment";
import PaginationSizing from "./PaginationSizing";

const PaginationsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Paginations} parent={BonusUi} title={Paginations} />
      <Container fluid>
        <Row>
          <DefaultPagination />
          <PaginationActiveAndDisabled />
          <PaginationWithIcons />
          <RoundedPagination/>
          <PaginationAlignment/>
          <PaginationSizing/>
        </Row>
      </Container>
    </>
  );
};

export default PaginationsContainer;
